import React from "react";
import PropTypes from "prop-types";

class BooleanToggle extends React.Component {
  constructor(props) {
    super(props);
    const { initialState, offText, onText } = this.props;
    this.state = {
      on: initialState,
      className: "",
      width: this.calcWidth(offText, onText)
    };

    this._toggleButton = this._toggleButton.bind(this);
  }

  calcWidth(offText, onText) {
    const offTextWidth = offText.size(500, "1.4rem Roboto").width;
    const onTextWidth = onText.size(500, "1.4rem Roboto").width;
    const offset = 37;
    return Math.max(offTextWidth, onTextWidth) + offset;
  }

  _toggleButton(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }
    const toggleButton = $(e.currentTarget);
    const toggleDot = $(toggleButton).find(".toggle-dot");
    const toggleText = $(toggleButton)
      .find(".toggle-text")
      .hide();
    const animateTo = {};
    if (this.state.on) {
      animateTo.left = -(toggleButton.width() - 25);
    } else {
      animateTo.marginLeft = toggleButton.width() - 20;
    }
    toggleDot.animate(animateTo, 250, () => {
      toggleDot.css("margin-left", "");
      toggleDot.css("left", "");
      toggleText.fadeIn(100);
      if (this.state.on) {
        this.props.toggleOff && this.props.toggleOff(e);
      } else {
        this.props.toggleOn && this.props.toggleOn(e);
      }
      this.setState(state => ({ on: !state.on }));
    });
  }

  render() {
    const toggleClass = this.state.on ? "on" : "off";
    const classes = "boolean-toggle no-highlight noButton";
    const disabledClass = this.props.disabled ? " disabled" : "";

    return (
      <button
        aria-pressed={this.state.on}
        aria-describedby={this.props.describedBy}
        aria-label={this.props.label}
        style={{ minWidth: this.state.width }}
        className={`${toggleClass} ${classes} ${disabledClass}`}
        onClick={this._toggleButton}
      >
        <div className={"toggle-dot"} />
        <span className={"toggle-text"}>
          {this.state.on ? this.props.onText : this.props.offText}
        </span>
      </button>
    );
  }
}

BooleanToggle.propTypes = {
  initialState: PropTypes.bool,
  disabled: PropTypes.bool,
  offText: PropTypes.string,
  onText: PropTypes.string,
  describedBy: PropTypes.string,
  label: PropTypes.string,
  toggleOff: PropTypes.func,
  toggleOn: PropTypes.func
};

BooleanToggle.defaultProps = {
  initialState: false,
  disabled: false,
  offText: "",
  onText: "",
  describedBy: "",
  label: ""
};

export { BooleanToggle };
